module.exports = __webpack_public_path__ + "img/icon_answer.b8816894.png";